import type { CategoryViewModel } from '@generated';
import { useLocalizationLabel } from '../i18n/useLocalizationLabel';

export interface CategoryWithLabel extends CategoryViewModel {
	label: string;
}

export function useGetCategoryLabel(): (categoryName: string) => string {
	const { t } = useLocalizationLabel();
	return (categoryName: string) => t(`CATEGORIES.${categoryName}.LABEL`);
}
